import { Divider, Grid, Typography, Box } from '@mui/material';
import useWindowSize from '@shared/hooks/useWindowsSize';

const HEADER_CELLS = [
  {
    label: 'Nombre y Apellido',
    xs: 6,
    md: 3,
    key: p => `${p.name} ${p.last_name}`,
  },
  { label: 'Edad', xs: 2, md: 1, key: p => p.age },
  { label: 'Documento', xs: 4, md: 2, key: p => p.dni },
  { label: 'País', xs: 6, md: 3, key: p => p.country },
  { label: 'Nacionalidad', xs: 6, md: 3, key: p => p.nationality },
];

const HeaderRow = ({ headerStyle }) => (
  <Grid container columnSpacing={2} sx={{ alignItems: 'center', px: 1 }}>
    {HEADER_CELLS.map(({ label, xs, md }) => (
      <Grid item xs={xs} md={md} key={label}>
        <Typography sx={headerStyle}>{label}</Typography>
      </Grid>
    ))}
  </Grid>
);

const DataRow = ({ pax, jindex, index, valueStyle }) => (
  <Grid
    container
    columnSpacing={2}
    key={`${index}-${jindex}`}
    sx={{
      alignItems: 'center',
      px: 1,
      py: 0.5,
      bgcolor: jindex % 2 === 0 ? '#fafafa' : 'transparent',
    }}
  >
    {HEADER_CELLS.map(({ key, label, xs, md }) => (
      <Grid item xs={xs} md={md} key={label}>
        <Typography sx={valueStyle}>{key(pax)}</Typography>
      </Grid>
    ))}
  </Grid>
);

const RoomInfo = ({ room, index }) => {
  const screenSize = useWindowSize();
  const isMobile = screenSize.width <= 600;

  const headerStyle = { color: '#000', fontWeight: 400 };
  const valueStyle = { color: '#000', fontWeight: 600 };

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      {/* Título */}
      <Typography sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}>
        Habitación {index + 1}
      </Typography>
      <Typography sx={{ fontWeight: 400, mb: 2 }}>{room.room}</Typography>

      <Divider sx={{ mb: 1 }} />

      {/* Desktop */}
      {!isMobile && (
        <>
          <HeaderRow headerStyle={headerStyle} />
          <Divider sx={{ mb: 1, mt: 1 }} />
          {room.passangers?.map((pax, jindex) => (
            <DataRow
              key={jindex}
              pax={pax}
              jindex={jindex}
              index={index}
              valueStyle={valueStyle}
            />
          ))}
        </>
      )}

      {/* Mobile */}
      {isMobile && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {room.passangers?.map((pax, jindex) => (
            <Box
              key={`${index}-${jindex}`}
              sx={{
                p: 2,
                border: '1px solid #E5E5E5',
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }}
            >
              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                Pasajero {jindex + 1}
              </Typography>
              {HEADER_CELLS.map(({ label, key }) => (
                <Typography key={label}>
                  <span style={headerStyle}>{label}: </span>
                  <span style={valueStyle}>{key(pax)}</span>
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default RoomInfo;
